import { lazy } from 'react';
import { CallbackPage } from '../pages/CallbackPage';

const ForgotPasswordPage = lazy(() => import('../pages/forgotPassword/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('../pages/resetPassword/ResetPasswordPage'));
const SignIn = lazy(() => import('../pages/signIn/Signin'));
const NoAccount = lazy(() => import('../pages/noAccount/NoAccount'));
export const noAuthRoutes = [
  {
    path: '/signin',
    component: SignIn,
    menuType: 'noAuth',
  },
  {
    path: '/login',
    component: SignIn,
    menuType: 'noAuth',
  },
  {
    path: '/forgot-password',
    component: ForgotPasswordPage,
    menuType: 'noAuth',
  },
  {
    path: '/complete-pw-recovery',
    component: ResetPasswordPage,
    menuType: 'noAuth',
  },
  {
    path: '/callback',
    component: CallbackPage,
    menuType: 'noAuth',
  },
  {
    path: '/noAccount',
    component: NoAccount,
    menuType: 'noAuth',
  },
];
